import * as React from 'react';
import {observer} from 'mobx-react';
import {ButtonCircle} from './button-circle';
import {SVGIcon} from './svg-icon';
import {colorBackground, colorContrast, colorWhite} from '../theme/color';
import {classes, style} from 'typestyle';
import {centerCenter, horizontal} from 'csstips';
import {em, important, px} from 'csx';
import {transitionQuickEase} from '../theme/transition';
import {constantHeaderHeight} from '../theme/constant';
import {zAppHeaderContainer} from '../theme/z';
import {mediaMobileOnly} from '../theme/media';

const PrismicDOM = require('prismic-dom');

export interface AppShuntCTAModel {

}

export interface AppShuntCTAProps {
  show: boolean;
  content: any;
  onClickSignUp(event: React.MouseEvent<any>): void;
  onClickClose(event: React.MouseEvent<any>): void;
  i18n?: {
    text: string;
  }
}

const DEFAULT_I18N = {
  text: 'Sign up now to experience the full benefits of Lickd'
};

@observer
export class AppShuntCTA extends React.Component<AppShuntCTAProps, any> {
  render() {
    const { i18n = DEFAULT_I18N, show, content, onClickClose } = this.props;

    return (
      <div className={classes(AppShuntCTA.styles.container, show && AppShuntCTA.styles.containerVisible)}>
        <span
          className={AppShuntCTA.styles.link}
          onClick={this.handleClick}
          dangerouslySetInnerHTML={{ __html: PrismicDOM.RichText.asHtml(content)}}
        />
        <ButtonCircle size={28} className={AppShuntCTA.styles.button} onClick={onClickClose}>
          <SVGIcon.Cross size={12} />
        </ButtonCircle>
      </div>
    )
  }

  handleClick = (event: React.MouseEvent<any>) => {
    if ((event.target as HTMLAnchorElement).href) {
      event.preventDefault();
      this.props.onClickSignUp(event);
    }
  };

  static styles = {
    container: style(
      {
        ...horizontal,
        ...centerCenter,
        fontSize: px(20),
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: constantHeaderHeight,
        transform: `translate3d(0,-${constantHeaderHeight},0)`,
        padding: '0 60px',
        background: colorContrast.toString(),
        color: colorWhite.toString(),
        zIndex: zAppHeaderContainer,
        opacity: 0,
      },
      mediaMobileOnly({
        lineHeight: em(1.4),
        fontSize: px(14),
        padding: '0 60px 0 16px',
      })
    ),
    containerVisible: style(),
    link: style({
      $nest: {
        '& a': {
          borderBottom: `1px solid ${colorWhite.toString()}`,
          transition: `all ${transitionQuickEase}`,
          color: colorWhite.toString(),
          textDecoration: 'none',
        },
        '& a:hover': {
          color: colorWhite.darken(0.15).toString(),
          borderBottom: `1px solid ${colorWhite.darken(0.15).toString()}`,
        }
      }
    }),
    button: style({
      position: 'absolute',
      top: px(14),
      right: px(17),
      backgroundColor: important(colorBackground.fade(0.2).toString()),
      $nest: {
        '&:hover': {
          backgroundColor: important(colorBackground.darken(0.15).fade(0.2).toString()),
        }
      }
    })
  }
}